/**
 * 检测模块
 */
import companyApi from '../../api/company.api';
// console.log(companyApi.getIndustries)

const state = {
    company: {
        name: '',
        industry: null,
        industryType: '',
        tel: '',
        address: ''
    },
    industries: [],
    isSaved: false,
    isDirty: false
};

const getters = {};

const mutations = {
    setCompany(state, company) {
        state.company = company;
    },
    setCompanyInfo(state, data) {
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                state.company[key] = data[key];
            }
        }
    },
    setIndustries(state, industries) {
        state.industries = industries;
    },
    setDirty(state) {
        state.isDirty = true;
        this.isSaved = false;
    },
    setSaved(state, isSaved) {
        state.isDirty = false;
        state.isSaved = isSaved;
    },
    clearCompany(state) {
        state.company = {};
        state.isSaved = false;
        state.isDirty = false
    }
};

const actions = {
    //设置token
    saveCompany({commit}, params) {
        return companyApi.save(params).then(data => {
            commit('setCompany', data);
            commit('setSaved', true);
            return data;
        })
    },
    getCompany({commit, dispatch}) {
        return companyApi.getCompany().then((company) => {
            company = company || {};
            commit('setCompany', company);
            dispatch('getIndustries');
            return company;
        })
    },
    getIndustries({state, commit}) {
        if (state.industries.length) {
            return state.industries;
        } else {
            return companyApi.getIndustries().then((items) => {
                commit('setIndustries', items);
                return items;
            })
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./app/store/modules/company.js